export const generic_colors = [
  "#7eb0d5",
  "#b2e061",
  "#bd7ebe",
  "#ffb55a",
  "#ffee65",
  "#fd7f6f",
  "#beb9db",
  "#fdcce5",
  "#2965CC",
  "#29A634",
  "#8bd3c7",
  "#D13913",
  "#D99E0B",
  "#8F398F",
  "#00B3A4",
  "#DB2C6F",
  "#9BBF30",
  "#96622D",
  "#7157D9",
  "#70cad1",
  "#a8e0ff",
  "#3e517a",
  "#0066CC",
  "#8ee3f5",
  "#666666",
  "#BBB6DF",
  "#b08ea2",
  "#CCCC99",
  "#FFCC66",
];
